<div class="modal-header">
  <h5 class="modal-title">Case Note</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div [innerHTML]="noteText"></div>
  
  <div class="note-details mt-3 pt-3 border-top">
    <p class="mb-1"><strong>Added By:</strong> {{byUserName}}</p>
    <p class="mb-0"><strong>Added Date:</strong> {{dateCreated | date:'dd/MM/yyyy HH:mm:ss'}}</p>
  </div>
</div>